import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CheckoutFullTaskFields from "../../../components/form/fields/checkout/CheckoutFullTaskFields";

export default function PackingField() {
  return (
    <Grid container spacing={1.5}>
      <Grid size={12}>
        <Typography fontWeight={500} fontSize={18}>
          Checkout
        </Typography>
      </Grid>
      <Grid size={12}>
        <CheckoutFullTaskFields isMobile name="notes.checkout_task" />
      </Grid>
    </Grid>
  );
}
